import BagCheckin from "@ixigo/icons/BagCheckin";
import Person from "@ixigo/icons/Person";
import Typography from "@ixigo/iui/Typography";

export interface CapacityItemProps {
  title: string;
  type: "PAX" | "BAGGAGE";
}

const IconMap: Record<CapacityItemProps["type"], React.ReactNode> = {
  PAX: <Person width={15} height={15} />,
  BAGGAGE: <BagCheckin width={15} height={15} />,
};

/**
 * CapacityItem component displays individual capacity information with appropriate icon
 * 
 * @param type - Type of capacity ("PAX" for passengers or "BAGGAGE" for luggage)
 * @param title - Description text for the capacity (e.g., "1-4 pax", "2 Bags")
 */
export const CapacityItem = ({ type, title }: CapacityItemProps) => {
  const icon = IconMap[type];
  
  return (
    <div className="flex items-center justify-center">
      <div className="text-secondary shrink-0 flex items-center">
        {icon}
      </div>
      <Typography variant="body-sm">{title}</Typography>
    </div>
  );
};